<template>
  <el-container class="page">
    <el-container class="login">
      <el-card style="width: 360px; padding: 16px;">
        <h3>Авторизация</h3>
        <el-form>
          <el-form-item prop="username">
            <el-input v-model="form.login" placeholder="Логин"></el-input>
          </el-form-item>
          <el-form-item prop="password">
            <el-input
              v-model="form.password"
              placeholder="Пароль"
              type="password"
            ></el-input>
          </el-form-item>
          <el-form-item>
            <el-button :loading="loading" type="primary" @click="login"
              >Войти</el-button
            >
          </el-form-item>
        </el-form>
      </el-card>
    </el-container>
  </el-container>
</template>

<script>
import { Notification } from "element-ui";

export default {
  name: "login",
  data() {
    return {
      loading: false,
      form: {
        login: "",
        password: ""
      }
    };
  },
  created() {
    const token = window.localStorage.getItem("token");
    if (token) {
      this.$router.push({ name: "Home" });
    }
  },
  methods: {
    async login() {
      this.loading = true;
      const result = await this.$axios.post("/api/auth/login", this.form);
      if (result.data && result.data.status == "success") {
        window.localStorage.setItem("token", result.data.data.token);
        this.$store.dispatch("updateUser");
        this.$router.push({ name: "Home" });
      } else {
        Notification.error({ title: "Ошибка", message: result.data.message });
      }
      this.loading = false;
      console.log(result);
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.page {
  width: 1240px;
  height: 100%;
}
.login {
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: center;
  margin: auto 0;
  height: 100%;
}
</style>